import { useState } from 'react';

type Props = {
  onSelectMenu: (index: number) => void;
};

export const useFloatSettingMenu = (props: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const onClickMenu = (e: React.MouseEvent<HTMLElement>) => {
    setAnchor(e.currentTarget);
  };

  const onSelectMenu = (selectedIndex: number) => {
    setAnchor(null);
    props.onSelectMenu(selectedIndex);
  };

  const onCloseMenu = () => {
    setAnchor(null);
  };

  return {
    state: {
      anchor,
    },
    actions: {
      onClickMenu,
      onSelectMenu,
      onCloseMenu,
    },
  };
};
